import React, { Component, Fragment } from "react";
import Achievment from "services/Achieved";
import { connect } from "react-redux";
import { ErrorMessage, PageMode } from "utils/constant";
import TableComponent from "./components/Table";
import FormComponent from "./components/Form";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import moment from "moment";

const AchievmentService = new Achievment();

class DataCapaianRumahSakit extends Component {
  _isMounted = true;
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      limit: 10,
      achievedData: [],
      selected_year: "",
      loading: true,
      mode: PageMode.view,
      selectedItem: null,
      currentPage: 1,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getAllCapaianData();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeMode = (mode) => {
    this.setState({ mode }, () => {
      if (mode === PageMode.view) {
        this.getAllCapaianData();
      }
    });
  };

  onPageChange = (page) => {
    this.setState({ page }, () => {
      this.getAllCapaianData();
    });
  };

  getAllCapaianData = async () => {
    await AchievmentService.getAll({
      searchBy: "fasyankes_id",
      searchValue: this.props.user.fasyankes_id,
    })
      .then((res) => {
        this.setState({
          loading: false,
          achievedData: res,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleChangeYear = (e) => {
    this.setState({ selected_year: moment(e).format("YYYY") });
  };

  onFilterData = (e) => {
    this.setState({ loading: true, selectedItem: null }, async () => {
      await AchievmentService.getAll({
        page: this.state.page,
        limit: this.state.limit,
        searchBy: "fasyankes_id,year",
        searchValue: `${this.props.user.fasyankes_id},${this.state.selected_year}`,
      })
        .then((data) => {
          if (this._isMounted) {
            this.setState({ loading: false, achievedData: data });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    });
  };

  onEdit = (item) => {
    this.setState({ selectedItem: item }, () => {
      this.changeMode(PageMode.edit);
    });
  };

  onRemove = (id) => {
    confirmAlert({
      title: "Anda yakin ingin menghapus data ini?",
      message: "Are you sure want to delete this data?",
      buttons: [
        {
          label: "Ya",
          onClick: () =>
            AchievmentService.remove(id)
              .then((data) => {
                if (this._isMounted) {
                  this.getAllCapaianData();
                }
                toast.success("Data berhasil dihapus", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((err) => {
                const errMsg = err.response.data.message ?? "";
                toast.error(
                  <>
                    Data gagal dihapus! <br />
                    Error: {errMsg}
                  </>,
                  {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  }
                );
                console.log(err);

                if (err.resonse.data.message === ErrorMessage.UserNotVerified) {
                  toast.error("Akun anda belum diverifikasi", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }

                if (
                  err.response.data.message ===
                  ErrorMessage.UserFaskesNotHaveAccess
                ) {
                  toast.error("Akun anda tidak memiliki akses", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });
                }
              }),
        },
        {
          label: "Tidak",
        },
      ],
    });
  };

  render() {
    const { achievedData, mode, selectedItem } = this.state;

    return (
      <Fragment>
        {mode === PageMode.view && (
          <TableComponent
            data={achievedData}
            handleChangeYear={this.handleChangeYear}
            onFilterData={this.onFilterData}
            currentUser={this.props.user}
            onEdit={this.onEdit}
            onRemove={this.onRemove}
            changeMode={this.changeMode}
            loading={this.state.loading}
            onPageChange={this.onPageChange}
          />
        )}
        {(mode === PageMode.add || mode === PageMode.edit) && (
          <FormComponent
            mode={mode}
            currentUser={this.props.user}
            changeMode={this.changeMode}
            data={selectedItem}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.authReducer.currentUser,
  };
};

export default connect(mapStateToProps)(DataCapaianRumahSakit);